<template>
<div class="app">
  <AppHeader />
  <div class="app-body">
    <Sidebar :navItems="nav" />
    <main class="main">
      <breadcrumb :list="list" />
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </main>
  </div>
  <AppFooter />
</div>
</template>

<script>
import
{
  mapGetters,
  mapActions
}
from 'vuex'
import
{
  Header as AppHeader,
  Sidebar,
  Footer as AppFooter,
  Breadcrumb
}
from '../components/admin/'

export default
{
  name: 'full',
  components:
  {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb
  },
  data()
  {
    var me = this;
    return {
      nav: []
    }
  },
  created()
  {
    if (this.langInitialized)
    {
      this.initMenu();
    }
  },
  methods:
  {
    initMenu()
    {
      var me = this;

      var cat = [];
      for (var value of me.globals.categories)
      {
        cat.push(
        {
          name: value.name,
          url: '/docs/' + value.categoryId,
          visible: true,
          icon: ''
        })
      }

      var admCat = [];
      for (var value of me.globals.adminCategories)
      {
        admCat.push(
        {
          name: value.name,
          url: '/admindocs/' + value.categoryId,
          visible: true,
          icon: ''
        })
      }

      var queCatUser = [];
      for (var value of me.globals.questionCategories)
      {
        queCatUser.push(
        {
          name: value.name,
          url: '/questionform/' + value.questionCategoryId,
          visible: true,
          icon: ''
        })
      }

      var queCat = [];
      for (var value of me.globals.questionCategories)
      {
        queCat.push(
        {
          name: value.name,
          url: '/cms/question/' + value.questionCategoryId,
          visible: true,
          icon: ''
        })
      }

      this.nav = [
      {
        name: me.$i18n.t('USER'),
        visible: true
      },
      {
        name: me.$i18n.t('DASHBOARD'),
        url: '/dashboard',
        visible: true,
        icon: 'columns'
      },
      {
        name: me.$i18n.t('ADMINDOCS'),
        icon: 'file',
        visible: (me.globals.acl.AdminDocuments && me.globals.acl.AdminDocuments.instantiate) ? true : false,
        children: admCat
      },
      {
        name: me.$i18n.t('HIVEDOCS'),
        icon: 'file-alt',
        visible: true,
        children: cat
      },
      {
        name: me.$i18n.t('WARRANTY'),
        url: '/warranty',
        visible: false,
        icon: 'recycle'
      },
      {
        name: me.$i18n.t('STORETOSTORETRANSFER'),
        url: '/storetostoretransfer',
        visible: (me.globals.acl.StoreToStoreTransfer && me.globals.acl.StoreToStoreTransfer.instantiate) ? true : false,
        icon: 'arrows-alt-h'
      },
      {
        name: me.$i18n.t('EXAMNEW'),
        url: '/examnew',
        visible: (me.globals.acl.TrainingBlock && me.globals.acl.TrainingBlock.instantiate) ? true : false,
        icon: 'check-square'
      },
      {
        name: me.$i18n.t('EXAM'),
        url: '/exam',
        visible: false,
        icon: 'check-square'
      },
      {
        name: me.$i18n.t('GOOGLEFORM'),
        children: queCatUser,
        visible: true,
        icon: 'question'
      },
      {
        name: me.$i18n.t('ADMIN'),
        visible: (me.globals.acl.Documents && me.globals.acl.Documents.insertAction) ? true : false,
      },
      {
        name: me.$i18n.t('CMS'),
        icon: 'plus-square',
        visible: (me.globals.acl.Documents && me.globals.acl.Documents.deleteAction) ? true : false,
        children: [
        {
          name: me.$i18n.t('BLOG'),
          url: '/cms/blog',
          visible: (me.globals.acl.Blog && me.globals.acl.Blog.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('ADMINDOCUMENTCATEGORIES'),
          url: '/cms/admindocumentcategories',
          visible: (me.globals.acl.AdminDocumentCategories && me.globals.acl.AdminDocumentCategories.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('ADMINDOCUMENTS'),
          url: '/cms/admindocuments',
          visible: (me.globals.acl.AdminDocuments && me.globals.acl.AdminDocuments.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('DOCUMENTS'),
          url: '/cms/documents',
          visible: (me.globals.acl.Documents && me.globals.acl.Documents.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('DOCUMENTCATEGORIES'),
          url: '/cms/documentcategories',
          visible: (me.globals.acl.DocumentCategories && me.globals.acl.DocumentCategories.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('QUESTIONCATEGORIES'),
          url: '/cms/questioncategories',
          visible: (me.globals.acl.QuestionCategories && me.globals.acl.QuestionCategories.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('QUESTIONFORM'),
          icon: '',
          visible: (me.globals.acl.QuestionForm && me.globals.acl.QuestionForm.insertAction) ? true : false,
          children: queCat
        }]
      },
      {
        name: me.$i18n.t('TRAINING'),
        icon: 'check-square',
        visible: (me.globals.acl.TrainingChapters && me.globals.acl.TrainingChapters.deleteAction && me.globals.acl.Quiz && me.globals.acl.Quiz.deleteAction) ? true : false,
        children: [
        {
          name: me.$i18n.t('TRAININGBLOCK'),
          url: '/training/trainingblock',
          visible: (me.globals.acl.TrainingBlock && me.globals.acl.TrainingBlock.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('TRAININGCHAPTERS'),
          url: '/training/trainingchapters',
          visible: (me.globals.acl.TrainingChapters && me.globals.acl.TrainingChapters.insertAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('QUIZ'),
          url: '/training/quiz',
          visible: (me.globals.acl.Quiz && me.globals.acl.Quiz.insertAction) ? true : false,
          icon: ''
        }]
      },
      {
        name: me.$i18n.t('USERS'),
        url: '/system/users',
        visible: (me.globals.acl.Users && me.globals.acl.Users.instantiate && me.globals.acl.Users.deleteAction) ? true : false,
        icon: 'user'
      },
      {
        name: me.$i18n.t('GOOGLEUSERFORMALL'),
        url: '/system/googleuserformall',
        visible: (me.globals.acl.QuestionForm && me.globals.acl.QuestionForm.instantiate && me.globals.acl.QuestionForm.insertAction) ? true : false,
        icon: 'user'
      },
      {
        name: me.$i18n.t('SALESPORTAL'),
        icon: 'chart-line',
        visible: (me.globals.acl.Store && me.globals.acl.Store.instantiate),
        children: [
        {
          name: me.$i18n.t('MANAGESTORES'),
          url: '/salesportal/store',
          visible: (me.globals.acl.Store && me.globals.acl.Store.instantiate) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('BUDGET'),
          url: '/salesportal/budget',
          visible: (me.globals.acl.StatisticsList && me.globals.acl.StatisticsList.deleteAction) ? true : false,
          icon: ''
        },
        {
          name: me.$i18n.t('REPORTS'),
          icon: '',
          visible: (me.globals.acl.StatisticsList && me.globals.acl.StatisticsList.deleteAction) ? true : false,
          children: [
          {
            name: me.$i18n.t('HOCONSOLIDATEMONTHLY'),
            url: '/salesportal/reports/hoconsolidatemonthly',
            visible: (me.globals.acl.StatisticsList && me.globals.acl.StatisticsList.deleteAction) ? true : false,
            icon: ''
          },
          {
            name: me.$i18n.t('CONSOLIDATEMONTHLY'),
            url: '/salesportal/reports/consolidatemonthly',
            visible: (me.globals.acl.StatisticsList && me.globals.acl.StatisticsList.deleteAction) ? true : false,
            icon: ''
          },
          {
            name: me.$i18n.t('WEEKLYPERFORMANCESUMMARY'),
            url: '/salesportal/reports/weeklyperformancesummary',
            visible: (me.globals.acl.StatisticsList && me.globals.acl.StatisticsList.deleteAction) ? true : false,
            icon: ''
          },
          {
            name: me.$i18n.t('WEEKLYMINIMUMSPLANNER'),
            url: '/salesportal/reports/weeklyminimumsplanner',
            visible: (me.globals.acl.StatisticsList && me.globals.acl.StatisticsList.deleteAction) ? true : false,
            icon: ''
          },
          {
            name: me.$i18n.t('STOREQUARTERLYMINIMUM'),
            url: '/salesportal/reports/storequarterlyminimum',
            visible: (me.globals.acl.StatisticsList && me.globals.acl.StatisticsList.deleteAction) ? true : false,
            icon: ''
          }]
        }]
      },
      {
        name: me.$i18n.t('SUPPORTTICKET'),
        url: '/system/ticket',
        visible: (me.globals.acl.Ticket && me.globals.acl.Ticket.instantiate && me.globals.acl.Ticket.deleteAction) ? true : false,
        icon: 'envelope'
      },
      {
        name: me.$i18n.t('SYSTEM'),
        icon: 'cog',
        visible: (me.globals.acl.AclPrivilages && me.globals.acl.AclPrivilages.insertRow && me.globals.acl.AclPrivilages.insertRow.instantiate) ? true : false,
        children: [
          {
            name: me.$i18n.t('ACL'),
            url: '/system/acl',
            visible: (me.globals.acl.AclPrivilages && me.globals.acl.AclPrivilages.insertRow && me.globals.acl.AclPrivilages.insertRow.instantiate) ? true : false,
            icon: 'lock'
          },
          {
            name: me.$i18n.t('TRANSLATOR'),
            url: '/system/translator',
            visible: (me.globals.acl.Translator && me.globals.acl.Translator.instantiate) ? true : false,
            icon: 'flag'
          },
          {
            name: me.$i18n.t('LANGUAGES'),
            url: '/system/languages',
            visible: (me.globals.acl.TransLang && me.globals.acl.TransLang.instantiate) ? true : false,
            icon: 'globe'
          },
          {
            name: me.$i18n.t('SITEPROPS'),
            url: '/system/siteprops',
            visible: false, //(me.globals.acl.SiteProps && me.globals.acl.SiteProps.instantiate) ? true : false,
            icon: 'wrench'
          },
          {
            name: me.$i18n.t('EMAILTEMPLATES'),
            url: '/system/emailtemplates',
            visible: false, //(me.globals.acl.EmailTemplates && me.globals.acl.EmailTemplates.instantiate) ? true : false,
            icon: 'envelope'
          },
          {
            name: me.$i18n.t('USERCOMPANIES'),
            url: '/system/usercompanies',
            visible: false, //(me.globals.acl.UserCompanies && me.globals.acl.UserCompanies.instantiate) ? true : false,
            icon: 'building'
          },
          {
            name: me.$i18n.t('GENERATOR'),
            url: '/system/generator',
            visible: false, //(me.globals.acl.Users && me.globals.acl.Users.instantiate) ? true : false,
            icon: 'rocket'
          }, //GENERATORINSERT
          {
            name: me.$i18n.t('TICKET'),
            url: '/system/ticket',
            visible: false, //(me.globals.acl.Ticket && me.globals.acl.Ticket.instantiate) ? true : false,
            icon: 'envelope'
          },
        ]
      }]
    }
  },
  watch:
  {
    translation()
    {
      this.initMenu();
    },
    langInitialized()
    {
      this.initMenu();
    }
  },
  computed:
  {
    ...mapGetters([
      'globals',
      'langInitialized',
      'translation'
    ]),
    name()
    {
      return this.$route.name
    },
    list()
    {
      return this.$route.matched
    }
  }
}
</script>
